import * as React from 'react';
import { useEffect, useState } from 'react';
import { Box, CardActions, CardHeader, CircularProgress, Container, FormControlLabel, Radio, RadioGroup, TextField } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2/Grid2';
import { Button } from '@mui/material';
import { Typography } from '@mui/material';
// import { ThreatSourceSelect } from './Component/RiskFormFields'; 
// import { ThreatEventSelect } from './Component/RiskFormFields';
// import { VulnerabilitySelect } from './Component/RiskFormFields';
// import { LikelihoodSelect } from './Component/RiskFormFields';
// import { AdverseImpactSelect } from './Component/RiskFormFields';
// import { InherentRisk1Select } from './Component/RiskFormFields';
// import { InherentRisk2Select } from './Component/RiskFormFields';
// import { ControlSelect } from './Component/RiskFormFields';
// import { ResidualRiskSelect } from './Component/RiskFormFields';
// import { CommentSelect } from './Component/RiskFormFields';
import {
    SuppilerSelect,
    SuppilerProduct,
    SuppilerService,
    Column4Select,
    Column5Select,
    SupplierRiskLevelSelect,

} from '../component/RiskFormFields';
import { supplyChainRiskAssesment } from '../../../modal';
import { useNavigate, useLocation } from 'react-router-dom';
import { createSupplyChainRiskAssessment, updateSupplyChainRiskAssessment } from '../../../helper';
import { useRiskAssessmentContext } from "../../../../../context/RiskAssessment/RiskAssessmentContext";
import DialogBoxComponent from '../../../../../components/DialogBoxComponent';
import { useUserContext } from '../../../../../context/auth/UserContext';
import { useAccessRights } from '../../../../../utils/useAccessRights';

const getTypographyStyles = () => ({
    //Typography styles
    fontWeight: 400,
    fontSize: '14px',
    fontStyle: 'italic',
    opacity: 0.6,
});

export default function SupplyChainAssesmentRiskForm() {
    const riskAssesment_Sc = useAccessRights("Risk Assessment - SC")
    const navigate = useNavigate();
    const { userId, companyProfileID } = useUserContext()

    const location = useLocation()
    const { action } = location.state || {};
    const [formTitle, setFormTitle] = useState<string>("Create Risk");
    const [isLoading, setIsLoading] = useState(false)
    const [dialogState, setDialogState] = useState({
        title: "",
        body: "",
        action: "",
        actionCancel: "",
        openSuccessDialogBox: false,
    });

    const initialFormValues: any = {
        supplierName: "",
        supplierProduct: "",
        supplierService: "",
        confidentialDataAccess: "No",
        criticalProcessesDependency: "No",
        supplierRiskLevel: "",
    };
    const [formValues, setFormValues] = React.useState<any>(initialFormValues);
    const {
        selectedSupplyChainRiskAssessment,
        setSelectedSupplyChainRiskAssessment,
        sC_RiskAssesmentList
    } = useRiskAssessmentContext();

    const handleChange = (event: { target: { name: any; value: any; }; }) => {
        // console.log("handleChange", event.target,);

        const { name, value } = event.target;
        // console.log("handleChange", name, value);

        setFormValues((prevValues: any) => ({
            ...prevValues,
            [name]: value,
        }));
    };



    const handleCancelForm = () => {
        navigate("/risk-assessment")
        setFormValues(initialFormValues)
        setSelectedSupplyChainRiskAssessment({})
    }
    const handleDialogCancel = () => {
        setDialogState({
            ...dialogState,
            openSuccessDialogBox: false,
        });
        if (dialogState.title === "Success") {
            handleCancelForm();
        }

    };

    const handleSubmitDuplicateCheck = () => {

        const duplicates = sC_RiskAssesmentList.some(list =>
            list.supplierName === formValues.supplierName &&
            list.supplierProduct === formValues.supplierProduct &&
            list.supplierService === formValues.supplierService
        )
        if (action === "Edit") {
            //Checking the actipn 
            if (selectedSupplyChainRiskAssessment.supplierName === formValues.supplierName &&
                selectedSupplyChainRiskAssessment.supplierProduct === formValues.supplierProduct &&
                selectedSupplyChainRiskAssessment.supplierService === formValues.supplierService) {
                //if no changes in first 3 column while edit 
                handleEditAssessment()
            }
            else if (duplicates) {
                // if duplicate present in list while edit
                setDialogState({
                    title: "Duplicate Found",
                    body: "Risk already exist",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                })
            } else {
                handleEditAssessment()
            }

        } else {
            //Checking Duplicates while creating
            if (duplicates) {
                setDialogState({
                    title: "Duplicate Found",
                    body: "Risk already exist",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                })
            }
            else {
                handleCreateAssessment()
            }
        }

    }

    const handleCreateAssessment = async () => {
        setIsLoading(true)
        try {
            const date = new Date();
            const payload = {
                supplierName: formValues.supplierName,
                supplierProduct: formValues.supplierProduct,
                confidentialDataAccess: formValues.confidentialDataAccess === "Yes" ? true : false,
                criticalProcessesDependency: formValues.criticalProcessesDependency === "Yes" ? true : false,
                supplierRiskLevel: formValues.supplierRiskLevel,
                supplierService: formValues.supplierService,
                companyProfileID: companyProfileID,
                createDate: date,
                createdBy: userId,
            };
            const res = await createSupplyChainRiskAssessment(payload);
            if (res.succeeded) {
                setDialogState({
                    title: "Success",
                    body: "Risk successfully created",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                });
            } else {
                setDialogState({
                    title: "Error",
                    body: "Unexpected Error",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                });
            }
        } finally {
            setIsLoading(false)
        }
    };

    const handleEditAssessment = async () => {
        setIsLoading(true)
        try {
            const date = new Date();
            const payload = {
                supplierId: selectedSupplyChainRiskAssessment?.supplierId,
                supplierName: formValues.supplierName,
                supplierProduct: formValues.supplierProduct,
                confidentialDataAccess: formValues.confidentialDataAccess === "Yes" ? true : false,
                criticalProcessesDependency: formValues.criticalProcessesDependency === "Yes" ? true : false,
                supplierRiskLevel: formValues.supplierRiskLevel,
                supplierService: formValues.supplierService,
                companyProfileID: companyProfileID,
                updateDate: date,
                updatedBy: userId,

            };
            const res = await updateSupplyChainRiskAssessment(payload);
            if (res.succeeded) {
                setDialogState({
                    title: "Success",
                    body: "Risk successfully updated",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                });
            } else {
                setDialogState({
                    title: "Error",
                    body: "Unexpected Error",
                    action: "OK",
                    actionCancel: "",
                    openSuccessDialogBox: true,
                });
            }
        } finally {
            setSelectedSupplyChainRiskAssessment({})
            setIsLoading(false)
        }
    };

    const disableForm = () => {
        const isAllFieldFilled = formValues.supplierName &&
            formValues.supplierProduct &&
            formValues.supplierService

        if (action === "Edit") {
            const isMatching =
                formValues.supplierName === selectedSupplyChainRiskAssessment.supplierName &&
                formValues.supplierProduct === selectedSupplyChainRiskAssessment.supplierProduct &&
                formValues.supplierService === selectedSupplyChainRiskAssessment.supplierService &&
                formValues.confidentialDataAccess === selectedSupplyChainRiskAssessment.confidentialDataAccess &&
                formValues.criticalProcessesDependency === selectedSupplyChainRiskAssessment.criticalProcessesDependency

            return isMatching || !isAllFieldFilled
        } else {
            return !isAllFieldFilled
        }
    };


    useEffect(() => {
        if (formValues.confidentialDataAccess === "Yes" || formValues.criticalProcessesDependency === "Yes") {
            setFormValues((prevValues: any) => ({
                ...prevValues,
                supplierRiskLevel: "Critical",
            }));
        } else {
            setFormValues((prevValues: any) => ({
                ...prevValues,
                supplierRiskLevel: "Non-Critical",
            }));
        }
    }, [formValues.confidentialDataAccess, formValues.criticalProcessesDependency]);
    useEffect(() => {

        if (action === "Edit") {
            setFormTitle("Edit Risk");
            setFormValues({
                supplierName: selectedSupplyChainRiskAssessment.supplierName,
                supplierService: selectedSupplyChainRiskAssessment.supplierService,
                supplierProduct: selectedSupplyChainRiskAssessment.supplierProduct,
                supplierRiskLevel: selectedSupplyChainRiskAssessment.supplierRiskLevel,
                confidentialDataAccess: selectedSupplyChainRiskAssessment.confidentialDataAccess,
                criticalProcessesDependency: selectedSupplyChainRiskAssessment.criticalProcessesDependency,

            });
        }
    }, [action]);

    return (
        <React.Fragment>
            <Container sx={{ p: 1, height: "100%" }}>
                <Card sx={{ borderRadius: '10px', overflow: 'hidden', height: "100%" }}>
                    <CardContent>
                        <Typography sx={{
                            fontWeight: 200,
                            opacity: 0.9
                        }}>
                            {formTitle}
                        </Typography>
                        {isLoading ? (
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    height: "100%",
                                }}
                            >
                                <CircularProgress />
                            </Box>
                        ) : (
                            <Container sx={{ mt: 1, height: "100%", display: "flex", flexDirection: "column" }} >
                                <CardContent  >
                                    <Grid
                                        sx={{ width: '100%', height: "100%", justifyContent: "center", alignItems: "center", m: 0 }}
                                        container
                                        columnSpacing={2}
                                        rowSpacing={3}
                                    >
                                        <Grid xs={12} sm={4}>
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Supplier Name <span style={{ color: 'red' }}> *</span>:</Typography>
                                                <TextField
                                                    label="Enter Supplier Name"
                                                    id="supplierName"
                                                    name="supplierName"
                                                    value={formValues.supplierName}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    margin="dense"
                                                    sx={{ backgroundColor: "#E4EBEF" }}
                                                />

                                            </React.Fragment>

                                        </Grid>

                                        <Grid xs={12} sm={4}>
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Supplier Product <span style={{ color: 'red' }}> *</span>:</Typography>
                                                <TextField
                                                    label="Enter Supplier Product"
                                                    id="supplierProduct"
                                                    name="supplierProduct"
                                                    value={formValues.supplierProduct}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    margin="dense"
                                                    sx={{ backgroundColor: "#E4EBEF" }}
                                                />

                                            </React.Fragment>

                                        </Grid>

                                        <Grid xs={12} sm={4}>
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Supplier Service <span style={{ color: 'red' }}> *</span>:</Typography>
                                                <TextField
                                                    label="Enter Supplier Service"
                                                    id="supplierService"
                                                    name="supplierService"
                                                    value={formValues.supplierService}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    fullWidth
                                                    size="small"
                                                    margin="dense"
                                                    sx={{ backgroundColor: "#E4EBEF" }}
                                                />

                                            </React.Fragment>

                                        </Grid>

                                        <Grid xs={12} sm={6}>
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Does the organization rely on the listed product or service for critical processes?</Typography>

                                                <RadioGroup
                                                    id="criticalProcessesDependency"
                                                    name="criticalProcessesDependency"
                                                    value={formValues.criticalProcessesDependency}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "criticalProcessesDependency",
                                                            value: e.target.value,
                                                        },
                                                    })}
                                                    sx={{ display: "flex", flexDirection: "row" }}

                                                >
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={<Radio />}
                                                        label="Yes"
                                                    />
                                                    <FormControlLabel
                                                        value="No"
                                                        control={<Radio />}
                                                        label="No"
                                                    />
                                                </RadioGroup>
                                            </React.Fragment>
                                        </Grid>
                                        <Grid xs={12} sm={6}>
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Does the supplier store, transmit, or access confidential organization or customer data?</Typography>

                                                <RadioGroup
                                                    id="confidentialDataAccess"
                                                    name="confidentialDataAccess"
                                                    value={formValues.confidentialDataAccess}
                                                    onChange={(e) => handleChange({
                                                        target: {
                                                            name: "confidentialDataAccess",
                                                            value: e.target.value,
                                                        },
                                                    })}
                                                    sx={{ display: "flex", flexDirection: "row" }}
                                                >
                                                    <FormControlLabel
                                                        value="Yes"
                                                        control={<Radio />}
                                                        label="Yes"
                                                    />
                                                    <FormControlLabel
                                                        value="No"
                                                        control={<Radio />}
                                                        label="No"
                                                    />
                                                </RadioGroup>
                                            </React.Fragment>
                                        </Grid>

                                        <Grid xs={12} sm={4} >
                                            <React.Fragment>
                                                <Typography sx={getTypographyStyles}>Supplier Risk Level:</Typography>
                                                <TextField
                                                    // label="Enter Supplier Risk Level"
                                                    id="supplierRiskLevel"
                                                    name="supplierRiskLevel"
                                                    value={formValues.supplierRiskLevel}
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    size="small"
                                                    fullWidth
                                                    disabled
                                                    margin="dense"
                                                    sx={{ backgroundColor: "#E4EBEF" }}

                                                />
                                            </React.Fragment>
                                        </Grid>

                                    </Grid>
                                </CardContent>
                                <CardActions sx={{ justifyContent: "end", display: "flex", flexDirection: "row" }} >
                                    <Button variant="contained" sx={{
                                        backgroundColor: '#0066FF1A',
                                        color: '#0066FF',
                                        '&:hover': {
                                            bgcolor: '#0066FF1A',
                                            '& .MuiTypography-root': {
                                                color: 'white',
                                            },
                                        },
                                        boxShadow: 0,
                                        textTransform: "none"
                                    }}

                                        onClick={handleCancelForm}
                                    >Cancel</Button>
                                    {action === "Edit" ? (
                                        <Button variant="contained" sx={{ textTransform: "none", boxShadow: 0, backgroundColor: "#0066FF" }} disabled={disableForm() || !riskAssesment_Sc?.isUpdate} onClick={handleSubmitDuplicateCheck}>Edit</Button>

                                    ) : (
                                        <Button variant="contained" sx={{ textTransform: "none", boxShadow: 0, backgroundColor: "#0066FF" }} disabled={disableForm() || !riskAssesment_Sc?.isCreate} onClick={handleSubmitDuplicateCheck}>Create</Button>
                                    )}
                                </CardActions>
                            </Container>
                        )}


                    </CardContent>
                </Card >
            </Container >
            {
                <DialogBoxComponent
                    openDialogBox={dialogState.openSuccessDialogBox}
                    dialogTitle={dialogState.title}
                    dialogAction={dialogState.action}
                    dialogBody={dialogState.body}
                    handleFunction={handleDialogCancel}
                />
            }
        </React.Fragment >
    );
}
